import { render, staticRenderFns } from "./CBProposalStockValues.vue?vue&type=template&id=5fc35c6f"
import script from "./CBProposalStockValues.vue?vue&type=script&lang=js"
export * from "./CBProposalStockValues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports